import { useLayoutEffect, useState } from 'react';
import { flushSync } from 'react-dom';

export function useWorldClock(active: boolean) {
  const [now, setNow] = useState(() => Date.now());
  useLayoutEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const tick = () => { if (!document.hidden) setNow(Date.now()); };
    // Commit the new day before the renderer's first resumed animation frame.
    const wake = () => { if (!document.hidden) flushSync(tick); };
    document.addEventListener('visibilitychange', wake);
    const timer = window.setInterval(tick, 10_000);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', wake);
    };
  }, [active]);
  return [now, setNow] as const;
}
